var styleDataHash = 'dfec9b85';  
export const injectCss = (() => {
  var css = `.lxLOq{color:rgba(0,0,0,.3);top:75px}.lxLOq,.okLMd{position:relative}.okLMd{top:50px}[dir] .okLMd{margin:0 24px 24px}.okLMd tr{height:40px}.qOQTI{display:flex;justify-content:space-between}[dir] .qOQTI{padding-top:30px}.XDsW5{flex-basis:min-content;flex-grow:1}.XDsW5,._3ExGw{align-self:center}._3ExGw{flex-basis:max-content;flex-grow:0}.kmaRl{font-weight:700}[dir] .kmaRl{padding-top:30px}.ptdab{display:inline-block;height:28px;line-height:28px}[dir] .ptdab{background:#f8f8f8;border:1px solid #484848;border-radius:2px;padding:2px 8px;text-align:center}[dir=ltr] .ptdab{box-shadow:1px 1px 0 rgba(0,0,0,.23)}[dir=rtl] .ptdab{box-shadow:-1px 1px 0 rgba(0,0,0,.23)}[dir=ltr] .ptdab~.ptdab{margin-left:8px}[dir=rtl] .ptdab~.ptdab{margin-right:8px}.g5ndb~.g5ndb:before{content:"  or  "}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "titleBorder": "lxLOq",
  "keymapTable": "okLMd",
  "keyEntry": "qOQTI",
  "description": "XDsW5",
  "keys": "_3ExGw",
  "group": "kmaRl",
  "button": "ptdab",
  "shortcut": "g5ndb"
};